<template>
  <div :id="'expert-documents-'+author.authorID" class="expertDocumentsList">
    <template v-for="(document, key) in documents" >

      <div class="row" :key="key+'-'+author.authorID+'-'+document.documentID" :id="'rowDoc-'+author.authorID+'-'+document.documentID+'-'+document.biblio">

        <internal-document-author v-if="document.publication === 'internal'" :context="context" v-model="documents[key]" :author="author"/>

        <template v-else>
          <div v-if="document" class="col-xs-12 well" :class="testInBoxes(document) ? 'docInBiblio' : ''" >
            <document-action :key="author.authorID+'-'+document.documentID+'-'+document.biblio" :document="document" :context="context" :biblioBoxes="biblioBoxes" v-model="document.biblio"></document-action>
            <div class="clearfix"></div>
            <div class="row" style="margin-top: 10px">
              <div class="col-md-2 col-xs-12 col-sm-3 item-label">
                <span>Title : </span>
              </div>
              <div class="col-md-10 col-xs-12 col-sm-9">
                <span v-html="document.title"></span>
              </div>
            </div>
            <div class="row" style="padding-top: 10px">
              <div class="col-md-2 col-xs-12 col-sm-3 item-label">
                <span>Authors : </span>
              </div>
              <div class="col-md-10 col-xs-12 col-sm-9">
                <a class="coAuthors-divider" v-for="(coAuthor, key) in document.co_authors" v-bind:key="key">{{ coAuthor.lastName }} {{coAuthor.firstName }}</a>
              </div>
            </div>

            <div class="row" style="padding-top: 10px" v-if="author.affiliation">
              <div class="col-md-2 col-xs-12 col-sm-3 item-label">
                <span>Affiliation :</span>
              </div>
              <div class="col-md-10 col-xs-12 col-sm-9">
                <div class="row">
                  <div class="col-xs-3 col-xs-offset-2 col-sm-offset-0 item-label">
                    <span>City </span>
                  </div>
                  <div class="col-xs-7 col-sm-9">
                    <span v-if="!author.affiliation.city || author.affiliation.city.length === 0">Incomplete</span>
                    <span v-else>{{author.affiliation.city}}</span>
                  </div>
                  <div class="col-xs-3 col-xs-offset-2 col-sm-offset-0 item-label">
                    <span>Country </span>
                  </div>
                  <div class="col-xs-7 col-sm-9">
                    <span v-if="!author.affiliation.country || author.affiliation.country.length === 0">Incomplete</span>
                    <span v-else>{{author.affiliation.country}}</span>
                  </div>
                  <div class="col-xs-3 col-xs-offset-2 col-sm-offset-0 item-label">
                    <span>Name </span>
                  </div>
                  <div class="col-xs-7 col-sm-9">
                    <span v-if="!author.affiliation.organisationName || author.affiliation.organisationName.length === 0">Incomplete</span>
                    <span v-else>{{author.affiliation.organisationName}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="padding-top: 10px" v-if="document.DOI">
              <div class="col-md-2 col-xs-12 col-sm-3 item-label">
                <span>DOI : </span>
              </div>
              <div class="col-md-10 col-xs-12 col-sm-9">
                <span> <a :href="'https://doi.org/'+document.DOI" target="_blank">{{document.DOI}}</a></span>
              </div>
            </div>
            <div class="row" style="padding-top: 10px">
              <div class="col-md-2 col-xs-12 col-sm-3 item-label">
                <span>Published by : </span>
              </div>
              <div class="col-md-10 col-xs-12 col-sm-9">
                <span> {{document.publication}}</span>
              </div>
            </div>

            <div class="row" style="padding-top: 10px">
              <div class="col-md-2 col-xs-12 col-sm-3 item-label">
                <span v-if=" typeSearched ===1"> Publication date :</span>  <span v-else>Publishing date : </span>
              </div>
              <div class="col-md-10 col-xs-12 col-sm-9">
                <span>{{ new Date(document.pubDate).getFullYear()}}</span>
                <span class="label label-info" v-if="document.newDocument === true">New</span>
              </div>
            </div>

            <div class="row" style="padding-top: 15px">
              <div class="col-md-2 col-xs-12 col-sm-3 item-label">
                <span>Abstract : </span>
              </div>
              <div class="col-md-10 col-xs-12 col-sm-9 " style="line-height: 1.8">
                <span v-html="document.abstract"></span>
              </div>
            </div>
            <div class="row" style="padding-top: 15px" v-if="document.sourceID && typeSearched !==1 && typeSearched !==3 && $user.isIdexlab() && !$user.isBasic()">
              <div class="col-md-2 col-xs-12 col-sm-3 item-label">
                <span>Source : </span>
              </div>
              <div class="col-md-10 col-xs-12 col-sm-9 text-right">
                <a
                    :href="providerDetails(document.sourceID).docLink ? providerDetails(document.sourceID).docLink+document.sourceDocumentID : '/search/reference/'+document.documentID"
                    target="_blank">
                  <img class="provider-img" :src="providerDetails(document.sourceID).imgSrc">
                </a>
              </div>
            </div>

          </div>
        </template>
      </div>
    </template>
    <div class="row" v-if="context.name === 'expertSelected' && typeof documents[0] !=='undefined'">
      <div class="col-xs-12 well">
        <div class="row">
          <div class="col-md-2 col-xs-6 item-label">
            <span>Added To list: </span>
          </div>
          <div class="col-md-4 col-xs-6 ">
            <span>{{documents[0].added_at }}</span>
          </div>
          <div class="col-md-2 col-xs-6 item-label">
            <span>Search Query: </span>
          </div>
          <div class="col-md-4 col-xs-6 ">
            <span>{{documents[0].search_terms }}</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<style>
.item-label {
  font-weight: bold;
}
.coAuthors-divider + .coAuthors-divider:before {
  content: ", ";
}
.selected {
  border-left: 5px solid #34495e;
}
.provider-img {
  height: 25px;
}
.docInBiblio{
  border-left: thick solid #3498db;
}
</style>
<script>

import DocumentAction from './DocumentAction'
import InternalDocumentAuthor from './InternalDocumentAuthor'
export default {
  name: 'DocumentAuthor',
  components: {InternalDocumentAuthor, DocumentAction},
  props: ['value', 'author', 'context', 'pubDateSelected', 'biblioBoxes'],
  watch: {
    value: function (val) {
      this.documents = val
    },
    pubDateSelected: function (pubDateSelected) {
      let documents = this.author.docs

      if (pubDateSelected.length !== 0) {
        documents = documents.filter((document) => {
          let date = new Date(document.pubDate).getFullYear()
          let tmpYear = pubDateSelected.find((year) => {
            return date === year.name
          })
          return typeof tmpYear !== 'undefined'
        })
      }
      this.documents = documents
    }
  },
  data () {
    return {
      documents: null,
      api_url: process.env.API_URL,
      typeSearched: 0
    }
  },
  beforeMount () {
    this.documents = this.value
    this.typeSearched = this.$route.query.typeSearched
  },
  methods: {
    providerDetails: function (sourceId) {
      let provider = {
        'imgSrc': '',
        'docLink': ''
      }
      switch (sourceId) {
        case 1:
          provider.imgSrc = this.api_url + '/sources/crowdsourced.png'
          break
        case 4:
          provider.imgSrc = this.api_url + '/sources/epo.gif'
          break
        case 9:
          provider.imgSrc = this.api_url + '/sources/springer.jpg'
          break
        case 10:
          provider.imgSrc = this.api_url + '/sources/orbis.png'
          break
        case 11:
          provider.imgSrc = this.api_url + '/sources/epo.gif'
          break
        case 12:
          provider.imgSrc = this.api_url + '/sources/edison.png'
          break
        case 13:
          provider.imgSrc = this.api_url + '/sources/ieee.png'
          provider.docLink = 'https://ieeexplore.ieee.org/document/'
          break
        case 17:
          provider.imgSrc = this.api_url + '/sources/hal.png'
          break
        case 23:
          provider.imgSrc = this.api_url + '/sources/microsoft-academic.png'
          provider.docLink = 'https://academic.microsoft.com/paper/'
          break
        case 24:
          provider.imgSrc = this.api_url + '/sources/lens.png'
          provider.docLink = 'https://www.lens.org/lens/scholar/article/'
          break
        case 26:
          provider.imgSrc = this.api_url + '/sources/crossref.jpeg'
          break
        case 27:
          provider.imgSrc = this.api_url + '/sources/core.png'
          break
        case 30 :
          provider.imgSrc = this.api_url + '/sources/semantics.png'
          break
      }
      return provider
    },
    testInBoxes: function (document = null) {
      if (document.biblio) {
        return true
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/DocumentAuthor.vue